import type { UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { siQueryKeyFactory } from "app/pages/sales-intelligence/query/queryKeyFactory";
import type { LastActivityDto } from "app/pages/sales-intelligence/services/userActivityService";
import userActivityService from "app/pages/sales-intelligence/services/userActivityService";

export const lastActivityQueryOptions = queryOptions({
    queryKey: siQueryKeyFactory.lastActivity(),
    queryFn(): Promise<LastActivityDto> {
        return userActivityService.fetchLastActivity();
    },
    staleTime: Number.POSITIVE_INFINITY,
});

export const useLastActivityQuery = (): UseQueryResult<string> => {
    return useQuery({
        ...lastActivityQueryOptions,
        select: (dto) => dto.lastActivity,
    });
};
